import { render, staticRenderFns } from "./ThisOrThatPreview.vue?vue&type=template&id=04a90e83&"
import script from "./ThisOrThatPreview.vue?vue&type=script&lang=js&"
export * from "./ThisOrThatPreview.vue?vue&type=script&lang=js&"
import style0 from "./ThisOrThatPreview.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ThisOrThatPreview.vue"
export default component.exports